import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Create,
  getSupliers,
  getProducts,
} from "adminApi/PurchaseItemApi/PurchaseItem";
import { validateForm } from "utils/validation";
import { PurchaseItemRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddPurchaseItemForm from "./Componates/AddPurchaseItemForm";
import fields from "../json/PurchaseItemFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const AddPurchaseItem = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize default form values from JSON field definitions
  const initialValues = formdata.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  const { values, errors, handleChange, setErrors } = useFormChange(
    initialValues,
    PurchaseItemRules
  );

  // Fetch products for line item dropdown
  const { data: productOptions, loading: loadingProducts } = useFetchAllData(getProducts);

  // Fetch suppliers for supplier dropdown
  const { data: supplierOptions, loading: loadingSuppliers } = useFetchAllData(getSupliers);

  // Handle form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => await Create({ data: formValues }),
    (vals) => {
      const err = validateForm(vals, PurchaseItemRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Purchase Item Created Successfully!"
  );

  // Exclude grand_total from rendered fields — it's calculated, not user-entered
  const JsonData = formdata.filter((field) => field.name !== "grand_total");

  return (
    <>
      {(loadingSubmit || loadingProducts || loadingSuppliers) && (
        <Spinner isSpinner={true} />
      )}
      <AddPurchaseItemForm
        fields={JsonData}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e, formData) => handleSubmit(e, formData)}
        loading={loadingSubmit}
        supplierOptions={supplierOptions}
        productOptions={productOptions}
        title="Add Purchase Item"
      />
    </>
  );
};

export default AddPurchaseItem;
